import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {OphButtonModule} from 'src/app/shared/design/oph-button/oph-button.module';
import {OphIconModule} from 'src/app/shared/design/oph-icon/oph-icon.module';
import {ProjectTaskDialogPanels} from '../project-task-dialog-constants';
import {OphXButtonComponent} from 'src/app/shared/design/oph-x-button/oph-x-button.component';

@Component({
  selector: 'projects-task-new-item-wrapper',
  standalone: true,
  imports: [OphButtonModule, OphIconModule, OphXButtonComponent],
  templateUrl: './projects-task-new-item-wrapper.component.html',
  styleUrl: './projects-task-new-item-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectsTaskNewItemWrapperComponent {
  @Input() activePanel: ProjectTaskDialogPanels;
  @Input() headerText: string;
  @Input() headerMarginBottom: number;
  @Input() hideButtons: boolean;
  @Input() contentPadding: string;
  @Input() panelIsValid: boolean;

  @Output() back = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
  @Output() skip = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();

  ProjectTaskDialogPanels = ProjectTaskDialogPanels;
}
